const translationsPrivacyRadio = {
  en: {
    privacyRadio: {
      flat_neighbours_consent_text:
        'I confirm my consent to the <1>collection and processing of personal data</1>, and I agree to the <2>Property Insurance Rules</2> and the <3>Voluntary Liability Insurance Rules for Neighbors</3>.',
    },
  },
  kz: {
    privacyRadio: {
      flat_neighbours_consent_text:
        'Мен <1>жеке деректерді жинауға және өңдеуге</1> келісімімді растаймын, сондай-ақ <2>Мүлікті ерікті сақтандыру ережелерімен</2> және <3>Көршілер алдындағы АҚЖ ерікті сақтандыру ережелерімен</3> келісемін.',
    },
  },
  ru: {
    privacyRadio: {
      flat_neighbours_consent_text:
        'Я подтверждаю <1>согласие на сбор и обработку персональных данных</1>, а также соглашаюсь с <2>Правилами страхования имущества</2> и с <3>Правилами страхования ГПО перед соседями</3>.',
    },
  },
};

export default translationsPrivacyRadio;
